/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { userListItemSchema } from "../userListItemSchema.ts";
import { z } from "zod/v4";

/**
 * @description Payload of Array of UserListItem
 */
export const listUsers200Schema = z.array(z.lazy(() => userListItemSchema));

/**
 * @description No description
 */
export const listUsers401Schema = z.any();

/**
 * @description No description
 */
export const listUsers403Schema = z.any();

export const listUsersQueryResponseSchema = z.lazy(() => listUsers200Schema);
